/**
 * Numerički stepper (+ / −) za textSize i lineSpacing.
 */

import React from 'react';

export default function Stepper({
  value,
  min,
  max,
  step,
  onChange,
  formatValue,
  classPrefix = 'ap',
  labels,
}) {
  const display = formatValue ? formatValue(value) : value;
  return (
    <div className={`${classPrefix}-uio-stepper`}>
      <button
        type="button"
        className={`${classPrefix}-uio-stepper-btn`}
        onClick={() => onChange(Math.max(min, +(value - step).toFixed(2)))}
        disabled={value <= min}
        aria-label={labels.decrease}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12" /></svg>
      </button>
      <span className={`${classPrefix}-uio-stepper-value`}>{display}</span>
      <button
        type="button"
        className={`${classPrefix}-uio-stepper-btn`}
        onClick={() => onChange(Math.min(max, +(value + step).toFixed(2)))}
        disabled={value >= max}
        aria-label={labels.increase}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
      </button>
    </div>
  );
}
